import InternalEventEmitter from './internal.js';
import WebSocketClient from './multiplexed.js';

class EventSystem {

  constructor() {

    this.internal = new InternalEventEmitter();
    this.webSocketClient = null;

  }

  async initializeWebSocketClient(configuration) {

    configuration.url = 'wss://' + window.location.host + '/__nativesocket';

    this.webSocketClient = new WebSocketClient(configuration);

    return this.webSocketClient.connect();

  }

  sendRequest(request, type) {

    return this.webSocketClient.sendRequest(request, type);

  }

  sendAPIRequest(method, path, urlParameters = {}, queryOptions = {}, payload = {}) {

    return this.webSocketClient.sendAPIRequest(method, path, urlParameters, queryOptions, payload);

  }

  sendRaw(service, method, options, blobField, blob) {

    return this.webSocketClient.sendRaw(service, method, options, blobField, blob);

  }

  getBufferedDataSize() {

    return this.webSocketClient.getBufferedDataSize();

  }

  tryAssociateWithObserverId(payload) {

    return this.webSocketClient.tryAssociateWithObserverId(payload);

  }

  disconnect() {

    return this.webSocketClient.disconnect();

  }

  subscribeForServerActions(path) {

    return this.webSocketClient.subscribeForServerActions(path);

  }

  logout() {

    return this.webSocketClient.logout();
  }

}

export default EventSystem;